
















































import { Component, Mixins, Watch, Prop } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'
import { debounce } from 'lodash'

// Models
import ItemRow from '@/models/ItemRow'
import Item from '@/models/Item'

// Mixins
import ErrorsMixin from '@/mixins/Errors'
import TableMixin from '@/mixins/Table'
import DateMixin from '@/mixins/Date'
import FiltersMixin from '@/mixins/Filter'

// Components
import ImageViewerValue from '@/components/common/ImageViewerValue.vue'


@Component({
  components: {
    ImageViewerValue
  }
})
export default class ProoversList extends Mixins(TableMixin, FiltersMixin, ErrorsMixin, DateMixin) {
  // Pagination
  offset = 0
  limit = 20
  end = false
  itemSearch = null

  @Getter('token') token
  @Getter('locale', { namespace: 'user' }) locale

  // @ts-ignore
  @Watch('itemSearch')
  updateSearch = debounce(async function(value) {
    this.offset = 0
    await this.fetch(false)
  }, 500)

  get params(): {} {
    const params = {
      limit: this.limit,
      offset: this.offset,
      search: this.itemSearch
    }

    return params
  }

  async fetch(add: boolean) {
    try {
      this.tableLoading = true
      const res = await this.$api.items.fetchItems(this.token, this.params)
      const items = res.data.map((item) => new ItemRow(item, this.locale))

      this.data = add ? [...this.data, ...items] : items
      this.end = items.length === 0
      // this.end = items.length === 0 || items.length < this.limit
      this.offset += this.limit
    } finally {
      this.tableLoading = false
    }
  }

  async mounted() {
    await this.fetch(false)
    const res = await this.$api.items.fetchItems(this.token, this.params)
    this.firstLoad = false
    this.hasData = res.data.length > 0
  }

  async loadMore() {
    await this.fetch(true)
  }

  async selectItem(item) {
    const res = await this.$api.items.fetchItem(this.token, item.id)
    this.$emit('select', new Item(res.data, this.locale))
  }
}
